import { SearchField as SourceSearchField } from 'SourceComponent/SearchField/SearchField.component';
import media, { WYSIWYG_MEDIA } from "Util/Media/Media";
import ClickOutside from 'Component/ClickOutside';
import {
    lazy,
    Suspense
} from 'react';

export const SearchOverlay = lazy(
    () => import(
        /* webpackMode: "lazy", webpackChunkName: "overlay" */
        'Component/SearchOverlay'
        )
);
export const UniversalIcon = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "icons" */
    'Component/UniversalIcon'
    ));

/** @namespace Component/SearchField/Component */
export class SearchField extends SourceSearchField {

    renderSearchIcon() {
        const { isActive, headerInverseIcons } = this.props;

        if (isActive) {
            return (
                <div
                  block="SearchField"
                  elem="CloseIcon"
                  role="button"
                  tabIndex="0"
                  onClick={ this.closeSearch }
                  aria-label={ __('Close') }
                >
                    <UniversalIcon
                        src={media(headerInverseIcons ? 'close_white.svg' : 'close.svg', WYSIWYG_MEDIA)}
                        alt="CloseIcon"
                        className="CloseIcon"
                    />
                </div>
            );
        }

        return (
            <div
              block="SearchField"
              elem="SearchIcon"
              role="button"
              tabIndex="0"
              onClick={ this.openSearch }
              aria-label={ __('Search') }
            >
                <UniversalIcon
                    src={media(headerInverseIcons ? 'search_white.svg' : 'search.svg', WYSIWYG_MEDIA)}
                    alt="SearchIcon"
                    className="SearchIcon"
                />
            </div>
        );
    }

    renderSearch() {
        const {
            searchCriteria,
            onSearchBarFocus,
            isActive,
            device
        } = this.props;

        return (
            <div
                block="SearchField"
                elem="SearchInnerWrapper"
            >
                <input
                    id="search-field"
                    ref={ this.searchBarRef }
                    block="SearchField"
                    elem="Input"
                    onFocus={ onSearchBarFocus }
                    onChange={ this.handleChange }
                    onKeyDown={ this.onSearchEnterPress }
                    value={ searchCriteria }
                    mods={ { isActive } }
                    placeholder={ __('Search products') }
                    autoComplete="off"
                    aria-label={ __('Search') }
                />
                { this.renderSearchIcon() }
                <Suspense fallback={ this.renderOverlayFallback() }>
                    <SearchOverlay
                        isHideOverlay={ true }
                        clearSearch={ this.clearSearch }
                        searchCriteria={ searchCriteria }
                    />
                </Suspense>
            </div>
        );
    }

    render() {
        const {
            isVisible,
            isActive
        } = this.props;

        return (
            <div block="SearchField" mods={ { isVisible, isActive } } id="SearchField">
                <ClickOutside onClick={ this.closeSearch }>
                    <div block="SearchField" elem="Wrapper">
                        { this.renderSearch() }
                    </div>
                </ClickOutside>
            </div>
        );
    }
}

export default SearchField;
